import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button, Layout, Menu, Tooltip } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

import CookieList from '../../constants/cookieList';
import { PERMISSION_MODULES, PERMISSION_SCREEN } from '../../constants/permissionData';
import UnsavedModal from '../../molecules/Modal/UnsavedModal';
import CookieService from '../../services/cookie.service';
import { checkPermission } from '../../utils/globalFunctions';

const { Sider } = Layout;
const { SubMenu } = Menu;

const SideNavMenu = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  let relative_path = location.pathname.includes('ProjectInformation')
    ? '/ProjectInformation'
    : location.pathname;

  const [projectRecord, setProjectRecord] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [defaultCapexKey, setDefaulCapexKey] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [proMenuButtonVisible] = useState(true);
  const [openKeys, setOpenKeys] = useState([]);
  const [keys, setKeys] = useState({
    current: null,
    temp: null,
  });
  const [capexRoute, setCapexRoute] = useState('');

  useEffect(() => {
    setKeys({ ...keys, current: relative_path });
    if (props?.location && props?.location?.state) {
      setProjectRecord(location?.state?.projectRecord);
    }
  }, []);

  useEffect(() => {
    setKeys({ ...keys, current: relative_path });
    if (props?.location && props?.location?.state) {
      setProjectRecord(props?.location?.state?.projectRecord);
    }
  }, [props]);

  const { userRole } = useSelector((state) => {
    return {
      userRole: state?.auth?.user?.user?.role?.roleSlug,
    };
  });

  const { projectList, user } = useSelector((state) => {
    return {
      projectList: state?.projects?.projects || [],
      user: state?.auth?.user?.user,
    };
  });

  const record = useMemo(() => {
    return searchParams.get('projectId')
      ? projectList?.find((projectItem) => projectItem?.id === searchParams.get('projectId'))
      : null;
  }, [projectList, searchParams.get('projectId')]);

  // Permission helper function
  const handlePermission = (permission, screenName = '', field = '') => {
    if (field) {
      return checkPermission(PERMISSION_MODULES.postContract, permission, screenName, field);
    }
    return checkPermission(PERMISSION_MODULES.postContract, permission, screenName);
  };

  // Check view permissions for Payment menu items (list views only)
  const hasPOViewPermission = handlePermission('view', PERMISSION_SCREEN.purchase_order_list);
  const hasInvoiceListViewPermission = handlePermission('view', PERMISSION_SCREEN.invoice_list);
  const hasInvoiceProjectPODashboardViewPermission = handlePermission(
    'view',
    PERMISSION_SCREEN.invoice_project_po_dashboard,
  );
  const hasInvoiceVendorPODashboardViewPermission = handlePermission(
    'view',
    PERMISSION_SCREEN.invoice_vendor_po_dashboard,
  );
  const hasInvoiceViewPermission =
    hasInvoiceListViewPermission ||
    hasInvoiceProjectPODashboardViewPermission ||
    hasInvoiceVendorPODashboardViewPermission;
  const hasExpeditingViewPermission = handlePermission('view', PERMISSION_SCREEN.expediting);

  const showModal = () => {
    return (
      <UnsavedModal
        className='header-unsaved'
        isModalVisible={modalVisible}
        handleOk={clearCookies}
        handleCancelUnsave={() => setModalVisible(false)}
      />
    );
  };

  const clearCookies = () => {
    CookieService.remove(CookieList.unsavedValue);
    CookieService.set(CookieList.unsavedValue, false);
    CookieService.remove(CookieList.createRequest);
    CookieService.set(CookieList.createRequest, false);
    setModalVisible(false);
    if (!!defaultCapexKey) {
      setCapexRoute(defaultCapexKey);
      setDefaulCapexKey(null);
      navigate(`${defaultCapexKey}?projectId=${searchParams?.get('projectId')}&tab=detailvc`);
    } else {
      onChangeMenu(keys.temp);
    }
  };

  const handleMenuClick = (key) => {
    let value = CookieService.get(CookieList.unsavedValue);
    let value2 = CookieService.get(CookieList.createRequest);
    if (value === true || value === 'true') {
      setModalVisible(true);
      setDefaulCapexKey(key);
    } else if (value2 === 'true' || value2 === true) {
      setModalVisible(true);
      setDefaulCapexKey(key);
    } else {
      setCapexRoute(key);
      navigate(`${key}?projectId=${searchParams?.get('projectId')}&tab=detailvc`);
    }
  };

  const onChangeMenu = (e) => {
    let value = CookieService.get(CookieList.unsavedValue);
    let value2 = CookieService.get(CookieList.createRequest);
    if (value === true || value === 'true') {
      setModalVisible(true);
      setKeys({ ...keys, temp: e });
    } else if ((value2 === 'true' || value2 === true) && !e.includes('Capex')) {
      setModalVisible(true);
      setKeys({ ...keys, temp: e });
    } else {
      setKeys({ ...keys, current: e });
      let record = projectRecord;
      switch (e) {
        case '/ProjectInformation':
          navigate(`/ProjectInformation?projectId=${searchParams?.get('projectId')}&tab=logistics`);
          break;
        case '/BOQDetails':
          navigate(`/BOQDetails?projectId=${searchParams?.get('projectId')}&tab=boqlisting`);
          break;
        case '/VendorDashboardManagement':
          break;
        case '/BudgetDashboardManagement':
          navigate(
            `/BudgetDashboardManagement?projectId=${searchParams?.get('projectId')}&tab=summaryBudget`,
          );
          break;
        case '/Tendering/BOQ':
          navigate(`/Tendering/BOQ?projectId=${searchParams?.get('projectId')}`);
          break;
        case '/Tendering/RFQ':
          navigate(`/Tendering/RFQ?projectId=${searchParams?.get('projectId')}`);
          break;
        case '/Tendering/CBA':
          navigate(`/Tendering/CBA?projectId=${searchParams?.get('projectId')}`);
          break;
        case '/RFPDashboardManagement':
          navigate(
            `/RFPDashboardManagement?projectId=${searchParams?.get('projectId')}&tab=createrfp`,
          );
          break;
        case '/AnalysisDashboardManagement':
          navigate(
            `/AnalysisDashboardManagement?projectId=${searchParams?.get('projectId')}&tab=detailvc`,
          );
          break;
        case '/OSNE/BOQDetails':
          navigate(`/OSNE/BOQDetails?projectId=${searchParams?.get('projectId')}&tab=boqlisting`);
          break;
        case '/OSNE/BudgetDashboardManagement':
          navigate(
            `/OSNE/BOQDetails?projectId=${searchParams?.get('projectId')}&tab=budgetsummary`,
          );
          break;
        case '/Payment/PurchaseOrder':
          navigate(
            `/Payment/PurchaseOrder?projectId=${searchParams?.get('projectId')}&tab=listing`,
          );
          break;
        case '/Payment/Invoice':
          navigate(`/Payment/Invoice?projectId=${searchParams?.get('projectId')}&tab=list`);
          break;
        case '/Payment/Expediting':
          navigate(`/Payment/Expediting?projectId=${searchParams?.get('projectId')}&tab=details`);
          break;
        default:
          break;
      }
    }
  };

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  const pathNameToMenuMap = {
    '/BOQDetails': 'sub1',
    '/BudgetDashboardManagement': 'sub1',
    '/RFPDashboardManagement': 'sub1',
    '/VendorDashboardManagement': 'sub1',
    '/AnalysisDashboardManagement': 'sub1',
    '/OSNE/BOQDetails': 'sub2',
    '/OSNE/BudgetDashboardManagement': 'sub2',
    '/TenderingDashboard': 'sub6',
    '/Tendering/BOQ': 'sub6',
    '/Tendering/RFQ': 'sub6',
    '/Tendering/CBA': 'sub6',
    '/Payment/PurchaseOrder': 'sub-purchasing',
    '/Payment/Invoice': 'sub-finance',
    '/Payment/Expediting': 'sub-delivery',
    '/Capex/9': 'sub3',
    '/Capex/10': 'sub3',
    '/Capex/11': 'sub3',
  };

  useEffect(() => {
    let newKeys;
    if (
      record?.businessUnitType === 'FF&E' ||
      record?.businessUnitType === 'OS&E' ||
      record?.businessUnitType === 'BOTH'
    ) {
      const subKey = pathNameToMenuMap[location.pathname];
      if (subKey) {
        newKeys = ['sub4', 'sub-budgeting', subKey];
      } else {
        newKeys = [];
      }
    } else if (record?.businessUnitType === 'CAPEX') {
      newKeys = [pathNameToMenuMap[location.pathname]].filter((item) => !!item) || [];
    }
    setOpenKeys(newKeys);
  }, [record]);

  return (
    <>
      {modalVisible ? showModal() : null}
      <div className='sider-ml-15 mt-15'>
        {proMenuButtonVisible ? (
          <Tooltip title={collapsed ? 'Open Menu' : 'Close Menu'} placement='right'>
            <Button
              type='link'
              className={collapsed ? '' : 'ml-15'}
              style={{ width: 'unset', height: 'unset' }}
              onClick={() => {
                setCollapsed(!collapsed);
              }}
              icon={React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined)}
            ></Button>
          </Tooltip>
        ) : null}
        <Sider
          trigger={null}
          collapsedWidth={0}
          collapsible
          collapsed={collapsed}
          theme='light'
          width='125'
        >
          <div>
            {process.env.REACT_APP_IS_CAPEX_ENABLED === 'true' &&
            process.env.REACT_APP_IS_OSNE_ENABLED === 'true' ? (
              <Menu
                selectedKeys={[
                  'FF&E',
                  'OS&E',
                  props?.tabName === 'budgetsummary'
                    ? '/OSNE/BudgetDashboardManagement'
                    : keys.current,
                ]}
                mode='inline'
                className='promenu'
                onSelect={(e) => onChangeMenu(e.key)}
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                id='sidebar_menu'
              >
                {userRole === 'admin' ||
                userRole === 'client' ||
                userRole === 'manager' ||
                userRole === 'coordinator' ||
                userRole === 'designer' ||
                userRole === 'operator' ? (
                  <Menu.Item
                    key='/ProjectInformation'
                    style={{ marginTop: '1rem', marginBottom: '1rem', minWidth: 125 }}
                    className='single-menu'
                    id='property_information'
                  >
                    Property Information
                  </Menu.Item>
                ) : null}
                {process.env.REACT_APP_IS_CAPEX_ENABLED === 'true' && userRole !== 'vendor' ? (
                  <SubMenu
                    key='sub3'
                    title='Capex'
                    style={{ marginBottom: '1rem' }}
                    defaultSelectedKeys={[capexRoute]}
                    onClick={(e) => handleMenuClick(e.key)}
                  >
                    <Menu.Item
                      key='/Capex/9'
                      disabled={
                        record?.businessUnitType === 'FF&E' ||
                        record?.businessUnitType === 'OS&E' ||
                        record?.businessUnitType === 'BOTH'
                      }
                    >
                      Create
                    </Menu.Item>
                    <Menu.Item
                      key='/Capex/10'
                      disabled={
                        record?.businessUnitType === 'FF&E' ||
                        record?.businessUnitType === 'OS&E' ||
                        record?.businessUnitType === 'BOTH'
                      }
                    >
                      Pending
                    </Menu.Item>
                    <Menu.Item
                      key='/Capex/11'
                      disabled={
                        record?.businessUnitType === 'FF&E' ||
                        record?.businessUnitType === 'OS&E' ||
                        record?.businessUnitType === 'BOTH'
                      }
                    >
                      Approved
                    </Menu.Item>
                  </SubMenu>
                ) : null}
                <SubMenu title='Projects' key='sub4'>
                  {/* ========== Budgeting ========== */}
                  <SubMenu key='sub-budgeting' title='Budgeting' style={{ marginBottom: '1rem' }}>
                    <SubMenu
                      key='sub1'
                      title='FF&E'
                      disabled={
                        record?.businessUnitType === 'CAPEX' || record?.businessUnitType === 'OS&E'
                      }
                    >
                      {userRole === 'admin' ||
                      userRole === 'manager' ||
                      userRole === 'client' ||
                      userRole === 'coordinator' ||
                      userRole === 'designer' ||
                      userRole === 'operator' ? (
                        <Menu.Item
                          key='/BOQDetails'
                          disabled={
                            record?.businessUnitType === 'CAPEX' ||
                            record?.businessUnitType === 'OS&E'
                          }
                          id='ffne_boq'
                        >
                          BoQ
                        </Menu.Item>
                      ) : null}
                      {userRole === 'admin' ||
                      userRole === 'vendor' ||
                      userRole === 'manager' ||
                      userRole === 'coordinator' ||
                      userRole === 'designer' ||
                      userRole === 'operator' ? (
                        <Menu.Item
                          key='/RFPDashboardManagement'
                          disabled={
                            record?.businessUnitType === 'CAPEX' ||
                            record?.businessUnitType === 'OS&E'
                          }
                          id='ffne_rfp'
                        >
                          RFP
                        </Menu.Item>
                      ) : null}
                      {userRole === 'admin' ||
                      userRole === 'manager' ||
                      userRole === 'coordinator' ||
                      userRole === 'designer' ||
                      userRole === 'operator' ? (
                        <Menu.Item
                          key='/AnalysisDashboardManagement'
                          disabled={
                            record?.businessUnitType === 'CAPEX' ||
                            record?.businessUnitType === 'OS&E'
                          }
                          id='ffne_analysis'
                        >
                          Analysis
                        </Menu.Item>
                      ) : null}
                      {userRole === 'admin' ||
                      userRole === 'client' ||
                      userRole === 'manager' ||
                      userRole === 'coordinator' ||
                      userRole === 'designer' ||
                      userRole === 'operator' ? (
                        <Menu.Item
                          key='/BudgetDashboardManagement'
                          disabled={
                            record?.businessUnitType === 'CAPEX' ||
                            record?.businessUnitType === 'OS&E'
                          }
                          id='ffne_budget'
                        >
                          Budget
                        </Menu.Item>
                      ) : null}
                    </SubMenu>
                    {userRole === 'admin' ||
                    userRole === 'client' ||
                    userRole === 'manager' ||
                    userRole === 'coordinator' ||
                    userRole === 'designer' ||
                    userRole === 'operator' ? (
                      <SubMenu
                        key='sub2'
                        title='OS&E'
                        disabled={
                          process.env.REACT_APP_IS_OSNE_ENABLED !== 'true' ||
                          record?.businessUnitType === 'CAPEX' ||
                          record?.businessUnitType === 'FF&E'
                        }
                      >
                        <Menu.Item
                          id='osne_boq'
                          key='/OSNE/BOQDetails'
                          disabled={
                            process.env.REACT_APP_IS_OSNE_ENABLED !== 'true' ||
                            record?.businessUnitType === 'CAPEX' ||
                            record?.businessUnitType === 'FF&E'
                          }
                        >
                          BOQ
                        </Menu.Item>
                        <Menu.Item
                          id='osne_budget'
                          key='/OSNE/BudgetDashboardManagement'
                          disabled={
                            process.env.REACT_APP_IS_OSNE_ENABLED !== 'true' ||
                            record?.businessUnitType === 'CAPEX' ||
                            record?.businessUnitType === 'FF&E'
                          }
                        >
                          Budget
                        </Menu.Item>
                      </SubMenu>
                    ) : null}
                  </SubMenu>

                  {/* ========== Tendering ========== */}
                  {userRole === 'admin' ||
                  userRole === 'manager' ||
                  userRole === 'coordinator' ||
                  userRole === 'designer' ||
                  userRole === 'operator' ? (
                    <SubMenu
                      key='sub6'
                      title='Tendering'
                      id='tendering'
                      style={{ marginBottom: '1rem' }}
                    >
                      <Menu.Item key='/Tendering/BOQ' id='tendering_boq'>
                        Packages
                      </Menu.Item>
                      <Menu.Item key='/Tendering/RFQ' id='tendering_rfq'>
                        RFQs
                      </Menu.Item>
                      <Menu.Item key='/Tendering/CBA' id='tendering_cba'>
                        CBA
                      </Menu.Item>
                      <Menu.Item key='awards' disabled id='tendering_awards'>
                        Awards
                      </Menu.Item>
                    </SubMenu>
                  ) : null}

                  {/* ========== Purchasing ========== */}
                  {userRole === 'admin' ||
                  userRole === 'client' ||
                  userRole === 'manager' ||
                  userRole === 'coordinator' ||
                  userRole === 'designer' ||
                  userRole === 'operator' ? (
                    <SubMenu
                      key='sub-purchasing'
                      title='Purchasing'
                      style={{ marginBottom: '1rem' }}
                    >
                      <Menu.Item key='purchasing-packages' disabled id='purchasing_packages'>
                        Packages
                      </Menu.Item>
                      {hasPOViewPermission && (
                        <Menu.Item
                          id='purchasing_po'
                          key='/Payment/PurchaseOrder'
                          disabled={record?.businessUnitType === 'CAPEX'}
                        >
                          Purchase Orders
                        </Menu.Item>
                      )}
                      <Menu.Item key='purchasing-contracts' disabled id='purchasing_contracts'>
                        Contracts
                      </Menu.Item>
                    </SubMenu>
                  ) : null}

                  {/* ========== Finance ========== */}
                  {hasInvoiceViewPermission &&
                  (userRole === 'admin' ||
                    userRole === 'client' ||
                    userRole === 'manager' ||
                    userRole === 'coordinator' ||
                    userRole === 'designer' ||
                    userRole === 'operator') ? (
                    <SubMenu key='sub-finance' title='Finance' style={{ marginBottom: '1rem' }}>
                      <Menu.Item
                        id='finance_invoice'
                        key='/Payment/Invoice'
                        disabled={record?.businessUnitType === 'CAPEX'}
                      >
                        Invoices
                      </Menu.Item>
                    </SubMenu>
                  ) : null}

                  {/* ========== Delivery ========== */}
                  {hasExpeditingViewPermission &&
                  (userRole === 'admin' ||
                    userRole === 'client' ||
                    userRole === 'manager' ||
                    userRole === 'coordinator' ||
                    userRole === 'designer' ||
                    userRole === 'operator') ? (
                    <SubMenu key='sub-delivery' title='Delivery' style={{ marginBottom: '1rem' }}>
                      <Menu.Item
                        id='delivery_expediting'
                        key='/Payment/Expediting'
                        disabled={record?.businessUnitType === 'CAPEX'}
                      >
                        Expediting
                      </Menu.Item>
                    </SubMenu>
                  ) : null}

                  {/* ========== Reports ========== */}
                  <SubMenu key='sub-reports' title='Reports' style={{ marginBottom: '1rem' }}>
                    <Menu.Item key='reports-budget-vs-actual' disabled id='reports_budget_actual'>
                      Budget vs Actual
                    </Menu.Item>
                  </SubMenu>
                </SubMenu>
              </Menu>
            ) : (
              <Menu
                selectedKeys={[keys.current]}
                mode='inline'
                className='promenu'
                onSelect={(e) => onChangeMenu(e.key)}
                openKeys={openKeys}
                onOpenChange={onOpenChange}
              >
                {userRole === 'admin' ||
                userRole === 'client' ||
                userRole === 'manager' ||
                userRole === 'coordinator' ||
                userRole === 'designer' ||
                userRole === 'operator' ? (
                  <Menu.Item
                    key='/ProjectInformation'
                    style={{ marginTop: '1rem', marginBottom: '1rem' }}
                    className='single-menu'
                    id='property_information'
                  >
                    Property Information
                  </Menu.Item>
                ) : null}
                {process.env.IS_CAPEX_AVAILABLE && userRole !== 'vendor' ? (
                  <SubMenu
                    key='sub3'
                    title='Capex'
                    style={{ marginBottom: '1rem' }}
                    defaultSelectedKeys={[capexRoute]}
                    onClick={(e) => handleMenuClick(e.key)}
                    disabled={
                      record?.businessUnitType === 'FF&E' ||
                      record?.businessUnitType === 'OS&E' ||
                      record?.businessUnitType === 'BOTH'
                    }
                  >
                    <Menu.Item
                      key='/Capex/9'
                      disabled={
                        record?.businessUnitType === 'FF&E' ||
                        record?.businessUnitType === 'OS&E' ||
                        record?.businessUnitType === 'BOTH' ||
                        user?.role?.roleName === 'Admin'
                      }
                    >
                      Create
                    </Menu.Item>
                    <Menu.Item
                      key='/Capex/10'
                      disabled={
                        record?.businessUnitType === 'FF&E' ||
                        record?.businessUnitType === 'OS&E' ||
                        record?.businessUnitType === 'BOTH'
                      }
                    >
                      Pending
                    </Menu.Item>
                    <Menu.Item
                      key='/Capex/11'
                      disabled={
                        record?.businessUnitType === 'FF&E' ||
                        record?.businessUnitType === 'OS&E' ||
                        record?.businessUnitType === 'BOTH'
                      }
                    >
                      Approved
                    </Menu.Item>
                  </SubMenu>
                ) : null}
                {process.env.IS_CAPEX_AVAILABLE &&
                record?.businessUnitType === 'CAPEX' &&
                userRole !== 'vendor' ? (
                  <SubMenu title='Projects'>
                    <Menu.Item style={{ width: '100%', margin: '0 0 10px 0' }}>
                      <SubMenu
                        title='FF&E'
                        style={{ marginBottom: '2.3rem', width: '100%' }}
                        disabled={record?.businessUnitType === 'CAPEX'}
                      />
                    </Menu.Item>
                    <Menu.Item style={{ width: '100%', margin: '0 0 10px 0' }}>
                      <SubMenu
                        title='OS&E'
                        style={{ marginBottom: '2.3rem' }}
                        disabled={record?.businessUnitType === 'CAPEX'}
                      />
                    </Menu.Item>
                  </SubMenu>
                ) : (
                  <SubMenu title='Projects' key='sub4'>
                    {/* ========== Budgeting ========== */}
                    <SubMenu key='sub-budgeting' title='Budgeting' style={{ marginBottom: '1rem' }}>
                      <SubMenu
                        key='sub1'
                        title='FF&E'
                        disabled={
                          record?.businessUnitType === 'CAPEX' ||
                          record?.businessUnitType === 'OS&E'
                        }
                      >
                        {userRole === 'admin' ||
                        userRole === 'manager' ||
                        userRole === 'client' ||
                        userRole === 'coordinator' ||
                        userRole === 'designer' ||
                        userRole === 'operator' ? (
                          <Menu.Item key='/BOQDetails' id='ffne_boq'>
                            BoQ
                          </Menu.Item>
                        ) : null}
                        {userRole === 'admin' ||
                        userRole === 'manager' ||
                        userRole === 'vendor' ||
                        userRole === 'coordinator' ||
                        userRole === 'designer' ||
                        userRole === 'operator' ? (
                          <Menu.Item key='/RFPDashboardManagement' id='ffne_rfp'>
                            RFP
                          </Menu.Item>
                        ) : null}
                        {userRole === 'admin' ||
                        userRole === 'manager' ||
                        userRole === 'coordinator' ||
                        userRole === 'designer' ||
                        userRole === 'operator' ? (
                          <Menu.Item key='/AnalysisDashboardManagement' id='ffne_analysis'>
                            Analysis
                          </Menu.Item>
                        ) : null}
                        {userRole === 'admin' ||
                        userRole === 'client' ||
                        userRole === 'manager' ||
                        userRole === 'coordinator' ||
                        userRole === 'designer' ||
                        userRole === 'operator' ? (
                          <Menu.Item key='/BudgetDashboardManagement' id='ffne_budget'>
                            Budget
                          </Menu.Item>
                        ) : null}
                      </SubMenu>
                      {userRole === 'admin' ||
                      userRole === 'client' ||
                      userRole === 'manager' ||
                      userRole === 'coordinator' ||
                      userRole === 'designer' ||
                      userRole === 'operator' ? (
                        <SubMenu
                          key='sub2'
                          title='OS&E'
                          disabled={record?.businessUnitType === 'CAPEX'}
                        >
                          <Menu.Item key='6' disabled={true} id='osne_boq'>
                            BOQ
                          </Menu.Item>
                          <Menu.Item key='8' disabled={true} id='osne_budget'>
                            Budget
                          </Menu.Item>
                        </SubMenu>
                      ) : null}
                    </SubMenu>

                    {/* ========== Tendering ========== */}
                    {userRole === 'admin' ||
                    userRole === 'manager' ||
                    userRole === 'coordinator' ||
                    userRole === 'designer' ||
                    userRole === 'operator' ? (
                      <SubMenu
                        key='sub6'
                        title='Tendering'
                        id='tendering'
                        style={{ marginBottom: '1rem' }}
                      >
                        <Menu.Item key='/Tendering/BOQ' id='tendering_boq'>
                          Packages
                        </Menu.Item>
                        <Menu.Item key='/Tendering/RFQ' id='tendering_rfq'>
                          RFQs
                        </Menu.Item>
                        <Menu.Item key='/Tendering/CBA' id='tendering_cba'>
                          CBA
                        </Menu.Item>
                        <Menu.Item key='awards' disabled id='tendering_awards'>
                          Awards
                        </Menu.Item>
                      </SubMenu>
                    ) : null}

                    {/* ========== Purchasing ========== */}
                    {userRole === 'admin' ||
                    userRole === 'client' ||
                    userRole === 'manager' ||
                    userRole === 'coordinator' ||
                    userRole === 'designer' ||
                    userRole === 'operator' ? (
                      <SubMenu
                        key='sub-purchasing'
                        title='Purchasing'
                        style={{ marginBottom: '1rem' }}
                      >
                        <Menu.Item key='purchasing-packages' disabled id='purchasing_packages'>
                          Packages
                        </Menu.Item>
                        {hasPOViewPermission && (
                          <Menu.Item
                            key='/Payment/PurchaseOrder'
                            disabled={record?.businessUnitType === 'CAPEX'}
                            id='purchasing_po'
                          >
                            Purchase Orders
                          </Menu.Item>
                        )}
                        <Menu.Item key='purchasing-contracts' disabled id='purchasing_contracts'>
                          Contracts
                        </Menu.Item>
                      </SubMenu>
                    ) : null}

                    {/* ========== Finance ========== */}
                    {hasInvoiceViewPermission &&
                    (userRole === 'admin' ||
                      userRole === 'client' ||
                      userRole === 'manager' ||
                      userRole === 'coordinator' ||
                      userRole === 'designer' ||
                      userRole === 'operator') ? (
                      <SubMenu key='sub-finance' title='Finance' style={{ marginBottom: '1rem' }}>
                        <Menu.Item
                          key='/Payment/Invoice'
                          disabled={record?.businessUnitType === 'CAPEX'}
                          id='finance_invoice'
                        >
                          Invoices
                        </Menu.Item>
                      </SubMenu>
                    ) : null}

                    {/* ========== Delivery ========== */}
                    {hasExpeditingViewPermission &&
                    (userRole === 'admin' ||
                      userRole === 'client' ||
                      userRole === 'manager' ||
                      userRole === 'coordinator' ||
                      userRole === 'designer' ||
                      userRole === 'operator') ? (
                      <SubMenu key='sub-delivery' title='Delivery' style={{ marginBottom: '1rem' }}>
                        <Menu.Item
                          key='/Payment/Expediting'
                          disabled={record?.businessUnitType === 'CAPEX'}
                          id='delivery_expediting'
                        >
                          Expediting
                        </Menu.Item>
                      </SubMenu>
                    ) : null}

                    {/* ========== Reports ========== */}
                    <SubMenu key='sub-reports' title='Reports' style={{ marginBottom: '1rem' }}>
                      <Menu.Item key='reports-budget-vs-actual' disabled id='reports_budget_actual'>
                        Budget vs Actual
                      </Menu.Item>
                    </SubMenu>
                  </SubMenu>
                )}
              </Menu>
            )}
          </div>
        </Sider>
      </div>
    </>
  );
};

export default SideNavMenu;
